import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.LOGIN_FORGOT_PASSWORD_VERIFY_REQUEST:
      return {
        ...state,
        data: null,
        isProgress: true,
      };
    case homeConstants.LOGIN_FORGOT_PASSWORD_VERIFY_SUCCESS:
      return {
        data: action.response,
        isProgress: false,
      };
    case homeConstants.LOGIN_FORGOT_PASSWORD_VERIFY_FAILURE:
      return {
        data: null,
        error: action.error,
        isProgress: false,
      };
    case homeConstants.RESET_LOGIN_FORGOT_PASSWORD_STATUS:
      return {
        ...state,
        data: null,
        isProgress: false,
      };
    default:
      return state;
  }
}
